import React from 'react'
import { DesignRow } from './DesignRow'

const DesignTable = ({
  items,
  actions,
  onRowClick,
  duplicatingDesignIds = new Set(),
  isAdmin = false,
  clientsMap = {},
}) => {
  return (
    <section style={{ width: '100%' }}>
      <header
        style={{
          paddingRight: '32px',
          marginBottom: '12px',
          display: 'flex',
          gap: '20px',
          justifyContent: 'space-between',
          alignSelf: 'stretch',
          marginTop: '44px',
          marginRight: '32px',
          width: '100%',
          fontSize: '14px',
          lineHeight: '1',
          color: '#6b7280',
        }}
      >
        <span style={{ width: '170px' }}>Front</span>
        <span style={{ width: '200px' }}>Design name</span>
        <span style={{ width: '20px' }}>Format</span>
        <span style={{ width: '50px' }}>Designer</span>
        {isAdmin && <span style={{ width: '100px' }}>Client</span>}
        <span style={{ width: '100px' }}>Date created</span>
        <span style={{ width: '80px' }}>Status</span>
        <span style={{ width: '20px' }}>Actions</span>
      </header>

      <div style={{ position: 'relative' }}>
        {items.map(item => (
          <DesignRow
            key={item.id}
            id={item.id}
            imageSrc={item.imageSrc}
            pdfSrc={item.pdfSrc}
            designName={item.designName}
            format={item.format}
            designer={item.designer}
            clientId={item.clientId}
            dateCreated={item.dateCreated}
            htmlContent={item.htmlContent}
            status={item.status}
            actions={actions}
            onRowClick={onRowClick}
            isDuplicating={duplicatingDesignIds.has(item.id)}
            isAdmin={isAdmin}
            clientsMap={clientsMap}
            designSource={item.designSource}
          />
        ))}
      </div>
    </section>
  )
}

export default DesignTable
